import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default ({ message }) => {
  return (
    <div className="flex px-6 py-3 mb-6 text-red-700 bg-red-100 border border-red-500 rounded">
      <span className="mr-3">
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </span>
      <span>{message}</span>
    </div>
  );
};
